<template>

  <b-card :class="customClass" class="backtotal">
    <div class="bold-text">
      {{ $t(title) }}
    </div>
    <div class="level-one-title ml-auto text-right">
      {{ value }}
    </div>
  </b-card>

</template>

<script>

export default {

  name: 'CardTotalComponent',

  props: {
    title: String,
    value: String,
    customClass: {
      type: String,
      default: ''
    }
  },

  methods: {}

}

</script>

<style scoped>

.backtotal {
  padding: 0;
  color: var(--main-white);
}

.backtotal > .card-body {
  padding: 0.25rem !important;
}



</style>



// WEBPACK FOOTER //
// src/views/operation/components/CardTotalComponent.vue